<template>
  <div>
    <view-options elementId="Website" />
    <div class="product-view" id="Website">
      <div>
        <div class="lds-ellipsis" v-if="loading">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>

        <section class="widget widget-goals">
          <h3 class="widget-title">¿Qué desempeño tuvo su sitio web?</h3>
          <div class="cards-wrapper">
            <card type="goals">
              <div class="card-header">
                <div class="icon-wrapper">
                  <font-awesome-icon icon="eye" />
                </div>
                <h4 class="card-title">Páginas vistas</h4>
              </div>
              <div class="card-content">
                <h1>{{ numberLetter(productData.totalImpressions) }}</h1>
                <p>
                  Número total de páginas de tu website que fueron visitadas
                </p>
              </div>
            </card>
            <card type="goals">
              <div class="card-header">
                <div class="icon-wrapper">
                  <font-awesome-icon icon="eye" />
                </div>
                <h4 class="card-title">Visitas</h4>
              </div>
              <div class="card-content">
                <h1>{{ numberLetter(productData.totalClicks) }}</h1>
                <p>Cantidad de veces que los usuarios visitaron tu website</p>
              </div>
            </card>
          </div>
        </section>
        <impressions
          :totalImpressions="productData.totalImpressions || 0"
          :impressions="impressionsSeries || []"
          :graphicLabel="'Total de páginas vistas'"
        ></impressions>
      </div>
      <mq-layout mq="laptop+">
        <section class="mobile-canvas">
          <img src="@/assets/images/website.png" alt />
        </section>
      </mq-layout>
      <section class="widget traffic-widget" v-if="trafficData.length > 0">
        <h3 class="widget-title">¿Cuál fue la fuente de su tráfico?</h3>
        <card>
          <div class="traffic-widget-wrapper">
            <div class="traffic-data">
              <div
                class="data"
                v-for="(trafficData, index) in trafficData.slice(0, 6)"
                :key="index"
              >
                <h1>
                  {{ Number.parseFloat(trafficData.sessions).toFixed(2) }}%
                </h1>
                <p class="capitalize">{{ trafficData.source }}</p>
              </div>
            </div>

            <apexchart
              type="pie"
              width="300"
              :options="trafficChartOptions"
              :series="trafficSeries"
            />
          </div>
        </card>
      </section>
      <section class="widget page-traffic" v-if="pageTraffic.length > 0">
        <h3 class="widget-title">Páginas donde aterrizaron sus usuarios</h3>
        <card>
          <table class="table">
            <thead>
              <th>Página</th>
              <th>Número de visitas</th>
            </thead>
            <tbody>
              <tr v-for="(pageTraffic, index) in pageTraffic" :key="index">
                <td>{{ pageTraffic.page }}</td>
                <td>{{ pageTraffic.visits.toLocaleString() }}</td>
              </tr>
            </tbody>
            <thead>
              <th></th>
              <th>Total: {{ pageTotal.toLocaleString() }}</th>
            </thead>
          </table>
        </card>
      </section>

      <div
        class="widget-area demographic-data"
        v-if="ageChartOptions.xaxis.categories.length !== 0"
      >
        <h3 class="widget-title">Datos demográficos sobre sus usuarios</h3>
        <section class="widget">
          <h5 class="widget-title">Género</h5>
          <card>
            <ApexchartBar
              type="bar"
              height="350"
              :headers="genderChartOptions.xaxis.categories"
              :series="genderSeries[0].data"
              :bar="true"
            />
          </card>
        </section>
        <section class="widget">
          <h5 class="widget-title">Edad</h5>
          <card>
            <ApexchartBar
              type="bar"
              height="350"
              :headers="ageChartOptions.xaxis.categories"
              :series="ageSeries[0].data"
              :bar="true"
            />
          </card>
        </section>
        <section class="widget">
          <h5 class="widget-title">Dispositivos</h5>
          <card>
            <ApexchartBar
              type="bar"
              height="250"
              :headers="devicesChartOptions.xaxis.categories"
              :series="devicesSeries[0].data"
              :bar="false"
            />
          </card>
        </section>
      </div>

      <div v-if="adListings.length > 0">
        <h3 class="widget-title">Un vistazo a sus anuncios de búsqueda</h3>
        <div class="widget-area two-column">
          <div class="widget ad-views">
            <div class="cards-wrapper carousel-google">
              <ad-listings
                :adListings="adListings"
                v-if="adListings.length > 0"
              ></ad-listings>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="export" id="export"></div>
  </div>
</template>
<script>
import ViewOptions from "@/components/ViewOptions.vue";
import Impressions from "@/components/Widgets/Impressions.vue";
import AdListings from "../../components/ApexchartCustom/AdListings-copy";
import ApexchartBar from "../../components/ApexchartCustom/ApexchartBar";
import { mapGetters } from "vuex";

// REQUEST
import GoogleWebsite from "../../services/Fase2/website";
import { validateProductExpirationDate } from "../../util";

export default {
  name: "website",
  components: {
    ViewOptions,
    Impressions,
    AdListings,
    ApexchartBar
  },
  data() {
    return {
      loading: true,
      Product: [],
      productData: {
        totalImpressions: 0,
        totalClicks: 0
      },
      keywordData: [],
      campaignData: [
        {
          name: "MNT 2019 BPYB + BPYS",
          clicks: 120,
          ctr: 20,
          cpc: 20
        }
      ],
      impressionsSeries: [{ count: "1259", date: "2019-12-05" }],
      impressionsChartOptions: {
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ],
        chart: {
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: [5, 7, 5],
          curve: "straight"
        },
        markers: {
          size: 0,

          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          categories: [
            "Jun '18",
            "Ago '18",
            "Oct '18",
            "Dic '18",
            "Feb '18",
            "Abr '18"
          ]
        },
        grid: {
          borderColor: "#f1f1f1"
        }
      },
      trafficSeries: [],
      trafficChartOptions: {
        colors: [
          "#0A286E",
          "#0E3593",
          "#1248C9",
          "#3772FF",
          "#08ACFF",
          "#93ABE6",
          "#BECDF0"
        ],
        labels: [],
        legend: {
          position: "bottom"
        },
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ]
      },
      genderSeries: [
        {
          data: []
        }
      ],
      genderChartOptions: {
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      ageSeries: [
        {
          data: []
        }
      ],
      ageChartOptions: {
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      devicesSeries: [
        {
          data: []
        }
      ],
      devicesChartOptions: {
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      adListings: [],

      trafficData: [],
      pageTotal: 0,
      pageTraffic: []
    };
  },
  watch: {
    // date1: {
    //   handler() {
    //     this.reload(this);
    //   },
    //   deep: true
    // },

    date2: {
      handler() {
        this.reload(this);
      },
      deep: true
    }
  },
  async created() {
    const context = this;
    this.reload(context);
  },
  methods: {
    reload: async function(context) {
      context.ageChartOptions.xaxis.categories = [];
      context.genderChartOptions.xaxis.categories = [];
      context.devicesChartOptions.xaxis.categories = [];

      context.ageSeries[0].data = [];
      context.genderSeries[0].data = [];
      context.devicesSeries[0].data = [];

      const { businessUnitId, subscriberId, productId } = context.$route.params;

      const products = context.$store.state.subscriber.products;
      const validatedFinalDate = validateProductExpirationDate(
        products,
        productId,
        context.$store.state.subscriber.date1
      );

      let fromDate =
        context.$store.state.subscriber.date2 > validatedFinalDate
          ? validatedFinalDate
          : context.$store.state.subscriber.date2;
      let toDate = validatedFinalDate;
      const pages = [];

      let pageTotal = 0;
      let googleAnalyticsData,
        googleAnalyticsUrlData,
        googleWebsiteDemographicData;

      try {
        [
          googleAnalyticsData,
          googleAnalyticsUrlData,
          googleWebsiteDemographicData
        ] = await Promise.all([
          new GoogleWebsite(context).getAnalyticsData(
            subscriberId,
            businessUnitId,
            fromDate,
            toDate
          ),
          new GoogleWebsite(context).getAnalyticsUrlData(
            subscriberId,
            businessUnitId,
            fromDate,
            toDate
          ),
          new GoogleWebsite(context).getGoogleDemographicData(
            subscriberId,
            businessUnitId,
            fromDate,
            toDate
          )
        ]);
      } catch (error) {
        this.loading = false;
        return false;
      }

      if (googleAnalyticsData && googleAnalyticsData.message) {
        this.loading = false;
        return false;
      }
      //demographicAge
      googleWebsiteDemographicData.demographicAge.criteria.forEach(element => {
        context.ageChartOptions.xaxis.categories.push(element.age);
        context.ageSeries[0].data.push(parseInt(element.views));
      });

      //demographicGenre

      googleWebsiteDemographicData.demographicGenre.criteria.forEach(
        element => {
          context.genderChartOptions.xaxis.categories.push(element.age);
          context.genderSeries[0].data.push(parseInt(element.views));
        }
      );

      //demographicDevice
      googleWebsiteDemographicData.demographicDevice.criteria.forEach(
        element => {
          context.devicesChartOptions.xaxis.categories.push(
            element.age.split(" ")[0]
          );
          context.devicesSeries[0].data.push(parseInt(element.views));
        }
      );

      //  pageTraffic

      (googleAnalyticsData.pagePaths || []).forEach(element => {
        if (element.pagePath) {
          const obj = {
            page: `/${element.pagePath.split("/")[1].split("?")[0]}`,
            visits: parseInt(element.pageviews)
          };

          pages.push(obj);

          pageTotal += parseInt(element.pageviews);
        }
      });

      //  visits
      const Impressions = [];
      var Visits = googleAnalyticsData.totalVisits;
      var Uniquevisits = googleAnalyticsData.totalUniqueViews;

      googleAnalyticsData.visitsByDate.forEach(element => {
        const obj = {
          count: element.pageviews,
          date: element.date
        };

        Impressions.push(obj);
      });

      context.productData.totalImpressions = parseInt(Visits);
      context.productData.totalClicks = Uniquevisits;
      context.impressionsSeries = Impressions;

      googleAnalyticsUrlData.forEach(element => {
        var url = "#";
        if (element.url.includes("http")) {
          url = `${element.url}`;
        } else {
          url = `http://${element.url}`;
        }

        context.adListings.push(url);
      });

      // =>>>>>>

      var unic = [];
      var unicArray = [];

      for (let op of pages) {
        unic[op.page] = op.visits + (unic[op.page] || 0);
      }

      for (let ob in unic) {
        var obj = {
          page: ob,
          visits: unic[ob]
        };
        unicArray.push(obj);
      }

      const capitalize = s => {
        if (typeof s !== "string") return "";
        return s.charAt(0).toUpperCase() + s.slice(1);
      };

      // =>>>>>>

      var googleTrafficLabels = [],
        googleTrafficValues = [];

      for (let i = 0; i <= googleAnalyticsData.sources.length - 1; i++) {
        googleTrafficLabels.push(
          capitalize(Object.values(googleAnalyticsData.sources[i])[1])
        );
        googleTrafficValues.push(
          Math.floor(parseInt(Object.values(googleAnalyticsData.sources[i])[0]))
        );
      }

      context.pageTotal = pageTotal;
      context.pageTraffic = unicArray.sort((a, b) => b.visits - a.visits);
      context.trafficData = googleAnalyticsData.sources;
      context.trafficSeries = googleTrafficValues.slice(0, 6);
      context.trafficChartOptions.labels = googleTrafficLabels.slice(0, 6);
      context.Product = [{}];

      this.loading = false;
    },

    numberLetter(value) {
      let suffixes = [
        "U",
        "D",
        "C",
        "K",
        "K",
        "K",
        "M",
        "M",
        "M",
        "B",
        "B",
        "B",
        "T",
        "T",
        "T"
      ];

      let stringValue = value.toString();
      let valueLength = stringValue.length;
      let suffix = suffixes[valueLength - 1];

      const BASEDIVISOR = 3;
      let startindex = 0;
      let characterToTake = valueLength % BASEDIVISOR;
      characterToTake = characterToTake == 0 ? BASEDIVISOR : characterToTake;

      if (valueLength > BASEDIVISOR) {
        let wholePart = stringValue.substr(startindex, characterToTake);
        let decimalPart = stringValue.substr(
          startindex + characterToTake,
          BASEDIVISOR
        );

        let firstDecimal = decimalPart.substr(startindex, 1);

        let wholeNumber =
          firstDecimal != "0"
            ? wholePart + "." + decimalPart.substr(startindex, 1) + suffix
            : wholePart + suffix;

        return wholeNumber;
      }

      return stringValue;
    }
  },
  computed: {
    ...mapGetters(["date1", "date2"])
  }
};
</script>
<style lang="scss" scoped>
.export {
  display: none;
}
.widget {
  &.widget-goals {
    .card-goals {
      .card-content {
        text-align: center;
        h1 {
          span {
            font-size: 35px;
          }
          font-size: 52px;
          font-weight: $font-medium;

          color: $highlight-color;
        }
      }
    }
  }
  &.brand-impact {
    .card-line-chart {
      .card-top {
        .card-number {
          text-align: center;
          h3 {
            color: $highlight-color;
          }
        }
      }
    }
  }
}

.traffic-data {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  text-align: center;
  grid-gap: 20px;
  margin-bottom: 20px;
  h1 {
    color: $highlight-color;
  }
}

.demographic-data {
  h5 {
    font-size: 16px;
    color: $blueish-gray-600;
  }
}

@include respond-above(sm) {
  .widget {
    &.widget-goals {
      .cards-wrapper {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 20px;
      }
    }
  }
  .traffic-data {
    grid-template-columns: repeat(3, 1fr);
  }
}

@include respond-above(md) {
  .product-view {
    display: grid;
    grid-template: 1fr auto / 1fr minmax(300px, 350px);
    grid-column-gap: 30px;
    max-width: 1000px;
    margin: 0 auto;
    .widget-look {
      grid-row: 1 / -1;
      grid-column: 2;
    }
    .widget {
      &.keyword-widget,
      &.campaign-widget {
        grid-column: 1 / -1;
      }
    }
    .demographic-data {
      grid-column: 1 / -1;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 30px;
      & > .widget-title {
        text-align: center;
        grid-column: 1 / -1;
        margin-bottom: 30px;
      }
      .widget:nth-child(4) {
        grid-column: 1 / -1;
      }
    }
    .two-column {
      grid-column: 1 / -1;
    }
    .ad-views {
      grid-column: 1 / -1;
      .cards-wrapper {
        display: grid;
        grid-gap: 30px;
      }
    }
  }
  .traffic-widget {
    grid-column: 1 / -1;
    .traffic-widget-wrapper {
      display: grid;
      grid-template-columns: 1fr 1fr;
      .traffic-data {
        justify-content: center;
        align-items: center;
        grid-gap: 5px;
        h1 {
          font-size: 2.5rem;
        }
      }
    }
  }
  .page-traffic {
    grid-column: 1 / -1;
  }
}

.two-column {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  .ad-data {
    ul {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
    }
  }

  .ad-views {
    grid-column: 1 / -1;
    .ad-listing {
      padding: 0;
    }
  }
  .cards-calls-website {
    grid-column: 1 / -1;
  }
}

.ad-data {
  text-align: center;
  h1 {
    font-size: 52px;
    font-weight: 500;
    color: #3576ff;
  }
}

@include respond-above(sm) {
  .two-column {
    .ad-views {
      grid-column: 1;
    }
    .cards-calls-website {
      grid-column: 2;
    }
    .ad-data {
      &.calls {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

// loading

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #3576ff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}

.capitalize {
  text-transform: capitalize;
}
</style>
